import React from 'react';
import styled from 'styled-components';
import { BackToHomeCTA, BackToMintproCTA } from 'components/header';
import { COLOR } from 'constants/colors';
import { useMediaQuery } from 'react-responsive';
import { CommonStyledComponentProps,LAMFStyledComponentProps } from '__utils/type';

const PopupCont = styled.div<CommonStyledComponentProps>`
    display: block;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1050;
    overflow: scroll;
    overflow-y: auto;
    transition: opacity .15s linear;
    background: ${(props: CommonStyledComponentProps) => props.isLAMF ? 'rgba(25, 28, 27, 0.7)' : 'rgba(255, 255, 255, 0.7)'}; 
`;

const VerticleAlignedCont = styled.div<LAMFStyledComponentProps>`
    position: absolute;
    top: 50%;
    left: 50%;
    -moz-transform: translate(-50%,-50%);
    -webkit-transform: translate(-50%,-50%);
    transform: translate(-50%,-50%);
    width: ${(props: LAMFStyledComponentProps) => props.isLAMF ? '' : '100%'};
    overflow-y: auto;
`;

const ModalOuterCont = styled.div`
    position: relative;
    /* width: 420px; */
    margin: 0 auto;
    transform: scale(1);
    -webkit-transform: scale(1);
    -moz-transform: scale(1);
    -ms-transform: scale(1);
    -webkit-animation-name: zommingEffect;
    -webkit-animation-duration: .3s;
    animation-name: zommingEffect;
    animation-duration: .3s;
    -webkit-transition: -webkit-transform .3s ease-out;
    -o-transition: -o-transform .3s ease-out;
    transition: transform .3s ease-out;

    -webkit-transform: translate(0,-25%);
    -ms-transform: translate(0,-25%);
    -o-transform: translate(0,-25%);
    transform: translate(0,-25%);

    -webkit-transform: translate(0,0);
    -ms-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
    .modal-padding{
        padding-top: 58px;
    }
`;

const ModalInnerCont = styled.div`
    position: relative;
    background-color: #fff;
    margin: 0 auto;
    border-radius: 8px;
    -moz-border-radius: 8px;
    -webkit-border-radius: 8px;
    box-shadow: 0 12px 32px 0 rgba(186,198,204,0.5);
    -moz-box-shadow: 0 12px 32px 0 rgba(186,198,204,0.5);
    -webkit-box-shadow: 0 12px 32px 0 rgba(186,198,204,0.5);
`;

const ModalHeader = styled.div`
    position: fixed;
    left: 0;
    width: 100%;
    top: 0;
    z-index: 1051;
`;

const ModalHeaderInnerCont = styled.div`
    position: relative;
    background-color: ${COLOR.WHITE};
    border-bottom: 1px solid lightgrey;
    height: 58px;
    padding: 12px 16px;
`;

const HeaderLeft = styled.div`
    float: left;
    position: relative;
`;

const HeaderRight = styled.div`
    float: right;
    position: relative;
`;

const ModalContent = styled.div`
    padding-top: 55px;
    background: #f5f5f5;
    // required for know-more popup
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    overflow: scroll;
    // height: 100vh;
`;

const ModalTitle = styled.h1<CommonStyledComponentProps>`
    position: relative;
    display: inline-block;
    top: 2px;
    font-weight: 400;
    font-size: ${(props: CommonStyledComponentProps) => props.isMobile ? '16px' : '18px'};
   // text-transform: capitalize;
`;

const ModalCloseIcon = styled.div<CommonStyledComponentProps>`
    display: inline-block;
    color: #031235;
    text-decoration: none;
    cursor: pointer;
    span {
        color: ${(props: CommonStyledComponentProps) => props.isMobile ? `${COLOR.BLACK}` : `${COLOR.GREY}`};
        font-size: ${(props: CommonStyledComponentProps) => props.isMobile ? '24px' : '28px'};
        position: relative;
        top: -6px;
    }
`;

interface PopupProps {
    title?: string,
    headerContent?: any,
    closable?: boolean,
    onClose?: Function,
    children: any,
    showBacktoMintPro?: boolean,
    showBacktoHome?: boolean,
    isLAMFPopup?:boolean,
    isLAMFRedeemPopup?:boolean,
    modalWidth?: string;
    style?: React.CSSProperties
}

const LargePopup: React.FC<PopupProps> = (props: PopupProps) => {

    const isMobile = useMediaQuery({ maxWidth: 767 });

    const closePopup = () => {
        if (props.onClose) props.onClose();
    }

    const flag = !props?.isLAMFRedeemPopup && !props?.isLAMFPopup;
    return (<PopupCont isMobile={isMobile} isLAMF={props?.isLAMFRedeemPopup} onClick={closePopup} >
        {(isMobile && flag) ? (<div>
            <ModalHeader onClick={(e) => e.stopPropagation()}>
                { props?.showBacktoMintPro && <BackToMintproCTA />}
                { props?.showBacktoHome &&<BackToHomeCTA />}
                {props.title ? <ModalHeaderInnerCont>
                    <HeaderLeft>
                        <ModalTitle isMobile={isMobile}>{props.title}</ModalTitle>
                    </HeaderLeft>
                    <HeaderRight>
                        {props.closable ? <ModalCloseIcon isMobile={isMobile} onClick={closePopup}><span>&times;</span></ModalCloseIcon> : null}
                    </HeaderRight>
                    <div style={{ clear: 'both' }}></div>
                </ModalHeaderInnerCont> : null}
                {props.headerContent ? <ModalHeaderInnerCont>{props.headerContent}</ModalHeaderInnerCont> : null}
            </ModalHeader>
           { <ModalContent onClick={(e:any) => e.stopPropagation()}>{props.children}</ModalContent>}
        </div>) : <VerticleAlignedCont isLAMF={props?.isLAMFRedeemPopup}>
                <ModalOuterCont onClick={(e) => e.stopPropagation()} style={{width: props?.modalWidth ?? '420px', ...props?.style}}>
                    <ModalInnerCont>
                        <ModalHeader>
                            {props.title ? <ModalHeaderInnerCont>
                                <HeaderLeft>
                                    <ModalTitle isMobile={isMobile}>{props.title}</ModalTitle>
                                </HeaderLeft>
                                <HeaderRight>
                                    {props.closable ? <ModalCloseIcon isMobile={isMobile} onClick={closePopup}><span>&times;</span></ModalCloseIcon> : null}
                                </HeaderRight>
                                <div style={{ clear: 'both' }}></div>
                            </ModalHeaderInnerCont> : null}
                        </ModalHeader>
                        {props.closable ? <div className={ props?.isLAMFRedeemPopup ? "darkBoxCloseBtn" : "lightboxCloseBtn" } style={ isMobile ? { top: "30px" } : { top: "24px" } }onClick={closePopup}></div> : null}
                        <div className={props.title  ? 'modal-padding' : ''}>{props.children}</div>
                    </ModalInnerCont>
                </ModalOuterCont>
            </VerticleAlignedCont>}
    </PopupCont>);
}

LargePopup.defaultProps = {
    closable: true
}

export default LargePopup;